// One description of a call, used to make it and to show it, so the "PowerShell" button cannot drift from what the page really sends.
// The query is built the way Invoke-cmaV3Request builds it (sorted, URL-encoded, empty values left out), so the URL is the same in
// the browser and in PowerShell.

const encode = (value) => encodeURIComponent(String(value)).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`);
const present = (v) => v !== null && v !== undefined && v !== '';

export const queryString = (params) => {
  const pairs = Object.keys(params || {}).sort().filter((k) => present(params[k])).map((k) => `${encode(k)}=${encode(params[k])}`);
  return pairs.length ? `?${pairs.join('&')}` : '';
};

// route is the whole route, for example 'v3/accounts'. path is what the API client is given (its base already ends in /api); url is the
// address as shown to a person. A call with a body (a PUT) carries it as `body`.
export const describeRequest = (route, params = {}, method = 'GET', body) => {
  const path = `${route}${queryString(params)}`;
  const call = { method, route, params, path, url: `/api/${path}` };
  if (body !== undefined && body !== null) call.body = body;
  return call;
};

const SIMPLE = /^[A-Za-z0-9_.@-]+$/;
const quote = (value) => (SIMPLE.test(String(value)) ? String(value) : `'${String(value).replace(/'/g, "''")}'`);
const pascal = (name) => name.charAt(0).toUpperCase() + name.slice(1);

// The command that makes the same call, from a route table entry ({command, parameters: [{name, in, ...}]}): the query parameters the call
// uses, in the table's order. A body is a JSON document: the command takes it from the pipeline, so it is shown as a here-string piped in.
export const toPowerShell = (entry, params = {}, body) => {
  const parameters = entry.parameters || [];
  const used = parameters.filter((p) => p.in !== 'body' && present((params || {})[p.name]));
  const command = [entry.command, ...used.map((p) => `-${pascal(p.name)} ${quote(params[p.name])}`)].join(' ');
  if (parameters.some((p) => p.in === 'body') && body !== undefined && body !== null) {
    return `@'\n${JSON.stringify(body, null, 2)}\n'@ | ConvertFrom-Json | ${command}`;
  }
  return command;
};
